import { Container, Text } from '@chakra-ui/react';
import { PrivacyPolicyContent } from '@shared/common/src/layouts';

import { config } from '../config';

const PrivacyPolicyPage = () => (
  <>
    <Container marginBottom='2rem'>
      <Text marginTop='2rem' fontSize='24px' marginBottom='2rem'>
        Privacy Policy
      </Text>
      <PrivacyPolicyContent projectName={config.name} domain={config.domain} email={config.email} />
    </Container>
  </>
);

export default PrivacyPolicyPage;
